import { render, staticRenderFns } from "./TransitionSpringLeft.vue?vue&type=template&id=21b32888&"
import script from "./TransitionSpringLeft.vue?vue&type=script&lang=js&"
export * from "./TransitionSpringLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports